import React from "react";
import PropTypes from "prop-types";

import BodyText from "core/BodyText";
import EditModal from "./EditModal";

import {
    Image,
    FooterContentContainer,
    ErrorBodyText,
    WarningBodyText,
    WarningIcon,
    SuccessIcon
} from "./styles";

const GridFooterContent = ({ file, hasError, hasWarning, hasSuccess }) => {
    const getStatus = () => {
        if (hasWarning) {
            return (
                <WarningBodyText data-testid="status-warning">
                    {file.warnings.message} <WarningIcon />
                </WarningBodyText>
            );
        }

        if (hasError) {
            return (
                <ErrorBodyText data-testid="status-error">
                    {file.errors.message}
                </ErrorBodyText>
            );
        }

        if (hasSuccess) {
            return <SuccessIcon data-testid="status-success" />;
        }

        return;
    };

    return (
        <FooterContentContainer
            justifyContent="space-between"
            alignItems="center"
        >
            {/* temporary content - will be updated in a future sprint */}
            <EditModal
                modalHeading="Editing selected photo"
                fileName={file.name}
            >
                <BodyText size="sm" type="p" bold>
                    File name:
                </BodyText>

                <BodyText size="lg" type="p">
                    {file.name}
                </BodyText>

                <Image
                    src={file.preview}
                    alt={`File name ${file.name}`}
                    style={{ width: "100%" }}
                />
            </EditModal>

            {/* todo in future sprint - add screen reader info for status to edit button */}
            {getStatus()}
        </FooterContentContainer>
    );
};

GridFooterContent.propTypes = {
    file: PropTypes.object.isRequired
};

export default GridFooterContent;
